import { status } from '../../config.ts'
import { campaignsPage1, campaignDetail } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/campaigns?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, campaignsPage1]
    }
  },
  {
    method: 'GET',
    path: '/campaigns/1',
    reply: async () => {
      await wait()
      return [status.ok, campaignDetail]
    }
  },
  {
    method: 'POST',
    path: '/campaigns',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/campaigns/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/campaigns/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
